import BaseModel from '../BaseModel';

export default class CandidateTestAnswer extends BaseModel {
  static entity = 'candidateTestAnswer';

  static primaryKey = 'id';

  static fields() {
    return {
      answer: this.attr(null),
      candidateId: this.attr(null),
      createdAt: this.attr(null),
      id: this.attr(null),
      testQuestionId: this.attr(null),
      updatedAt: this.attr(null),
    };
  }
}
